import { useQuery } from "@apollo/client";

import FacilityAutocomplete from "@/features/facility/components/ContactDetails/forms/inputs/FacilityAutocomplete";

import { FACILITY_ENUM_OPTIONS_QUERY } from "../../queries";
import { EnumSelectField, FormTextField, optionsWithEmpty } from "./shared";

export default function FacilityInformationStep() {
  const { data: optionsData } = useQuery(FACILITY_ENUM_OPTIONS_QUERY);

  return (
    <div className="flex flex-col gap-6">
      <p className="text-title-large">Enter details about the facility.</p>
      <FormTextField className="w-full" name="name" label="Facility Name" required />
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        <EnumSelectField
          name="facilityType"
          label="Facility Type"
          options={optionsWithEmpty(optionsData?.facilityTypeOptions.enumValues)}
          required
        />
        <EnumSelectField
          name="operatingStatus"
          label="Operating Status"
          options={optionsWithEmpty(optionsData?.operatingStatusOptions.enumValues)}
          required
        />
      </div>
      <FormTextField
        className="w-full"
        name="website"
        label="Website"
        placeholder="https://example.com"
        supportingText="Must start with http:// or https://"
        required
      />
      <FacilityAutocomplete name="parentCompanyId" label="Parent Company" initialQuery="" excludeIds={[]} />
    </div>
  );
}
